import { Link } from "react-router-dom";
import { animeCategories, animes } from "@/mocks/anime";

export default function QuickCategories() {
  return (
    <section className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-2 flex items-center gap-1.5 font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-layout-grid-line text-xs" />
              Browse by genre
            </span>
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">按类型快速找番</h2>
            <p className="mt-2 text-sm text-foreground-600">十二个主要类型，覆盖热血、奇幻、治愈与古风，点一下直达对应片单。</p>
          </div>
          <Link
            to="/category"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
          >
            全部分类
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-3 gap-3 sm:grid-cols-4 lg:grid-cols-6">
          {animeCategories.map((category) => {
            const total = animes.filter((item) => item.genres.includes(category.name)).length;
            return (
              <Link
                key={category.name}
                to={`/category?genre=${encodeURIComponent(category.name)}`}
                className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${category.icon} text-xl`} />
                </span>
                <span className="text-sm font-medium text-foreground-900">{category.name}</span>
                <span className="font-label text-[11px] text-foreground-500">{total} 部作品</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}